export const MAX_ALLOWANCE = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'

export enum TransactionStatusEnum {
    None = 'None',
    PendingSignature = 'PendingSignature',
    Mining = 'Mining',
    Success = 'Success',
    Fail = 'Fail',
    Exception = 'Exception',
}
